<template lang="pug">
v-dialog(:fullscreen="$vuetify.breakpoint.smAndDown"  v-model="show" scrollable persistent max-width="500px" )
  v-card.elevation-0.pa-0(flat height="500px" )
    v-card-title.pa-0.pt-2
      v-btn(color="primary" text @click="onCloseDialog")
        v-icon fas fa-times
    v-card-text.pa-0.pt-2
      v-row.ma-0
        v-col.text-center(cols="12")
          QrCode(ref="qrCode" :value="value" :size="250" level="H")
      v-row.ma-0.mt-5
        v-col.pa-0.text-center(cols="12")
          v-btn(color="primary" @click="onPrintQrCodeClick" :loading="printInProgress") {{$t('dashboardPage.printQrCode')}}


</template>

<script lang="ts">
import Vue from 'vue'
import { USER_LOGGED_IN } from '@/store/getter-types'
import QrCode from 'qrcode.vue'
import { Component, Prop } from 'vue-property-decorator'
import { CurrentUser } from '@/model/CurrentUser'
import { printSingleLabel } from '@/services/pdf-print'

@Component({
  components: {
    QrCode,
  }
})
export default class UserQrCode extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean

  $refs!: {
    qrCode: InstanceType<typeof QrCode>
  }

  printInProgress: boolean = false

  get currentUser (): CurrentUser {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get value (): string {
    return this.$store.getters[USER_LOGGED_IN].getBoarderQRCode
  }

  onCloseDialog () {
    this.$emit('close')
  }

  async generatePdf (): Promise<void> {
    try {
      this.printInProgress = true

      const qrCodeElement: HTMLCanvasElement | undefined = this.$refs.qrCode!.$refs['qrcode-vue'] as HTMLCanvasElement
      const qrCodeDataUrl: string = qrCodeElement.toDataURL()

      await printSingleLabel(qrCodeDataUrl, this.currentUser.fullName)
    } catch (error) {
      console.error('Error generating PDF:', error)
    } finally {
      this.printInProgress = false
    }
  }

  onPrintQrCodeClick (): void {
    this.generatePdf()
  }
}
</script>

<style lang="stylus" scoped>

</style>
